import { Directive, HostBinding, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  // eslint-disable-next-line max-len
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: `ui-input,
    ui-number-input,
    ui-checkbox, ui-textarea`,
  standalone: false,
})
export class CommonFieldStatusesDirective {
  private cd = inject(NgControl, { optional: true });

  @HostBinding('class.ui-is-valid') get getValidClass() {
    if (this.cd) return this.cd.control?.status === 'VALID';
    return '';
  }

  @HostBinding('class.ui-is-pending') get getPendingClass() {
    if (this.cd) return this.cd.control?.status === 'PENDING';
    return '';
  }

  @HostBinding('class.ui-is-not-empty') get getNotEmptyClass() {
    if (this.cd) {
      return this.cd.control?.value !== null && this.cd.control?.value !== '' && this.cd.control?.value !== undefined;
    }
    return '';
  }

  @HostBinding('class.ui-is-disabled') get getDisabledClass() {
    if (this.cd) return this.cd.control?.disabled;
    return '';
  }
}
